import { observer } from "mobx-react";
import { useParams } from "react-router-dom";
import { useCurrentOrganisationId } from "../../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { useEffect, useState } from "react";
import { ProjectStakeholdersGridModalModel } from "./ProjectStakeholdersGridModal_model";
import { PositionedSpinner } from "@flightpath/coreui/dist/ui/PositionedSpinner";
import { GridTypes } from "../../../../../../../../enums";
import { ProjectStakeholdersGrid } from "../../ProjectStakeholdersGridView_view";

interface ProjectStakeholdersGridModalViewProps {
  onAssignSuccess: (selectedItemIds: number[]) => void;
  selectedLinkItemIds?: number[];
}
const ProjectStakeholdersGridModalView: React.FunctionComponent<ProjectStakeholdersGridModalViewProps> = observer(
  ({ onAssignSuccess, selectedLinkItemIds }) => {
    const { projectId } = useParams<{ projectId: string }>();
    const organisationId = useCurrentOrganisationId();
    const [model] = useState(
      () => new ProjectStakeholdersGridModalModel(+organisationId, +projectId, selectedLinkItemIds)
    );

    useEffect(() => {
      model.onMount();
      return () => model.onUnmount();
      //eslint-disable-next-line
    }, []);

    if (model.isLoading) return <PositionedSpinner />;

    return (
      <div className="proj-stakeholders-modal-view insight-tab-content__space-filler" style={{ height: "100%" }}>
        <ProjectStakeholdersGrid
          isLoading={model.isLoading}
          data={model.projectStakeholders}
          columnDefs={model.projectStakeholderColDefs}
          gridToolbarType="link-modal"
          onAssignSuccess={onAssignSuccess}
          preSelectedItemIds={selectedLinkItemIds}
          gridType={GridTypes.PROJECT_STAKEHOLDERS_MODAL_GRID}
        />
      </div>
    );
  }
);

export { ProjectStakeholdersGridModalView };
